import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Menu, message, Row } from 'antd';
import { History } from 'history';
import { ClickParam } from 'antd/lib/menu';
import {
  FaUserCircle,
  FaBell,
  FaQuestionCircle,
  FaEnvelope,
  FaAlignJustify,
  FaSignOutAlt,
} from 'react-icons/fa';
import { logoutuser } from '../../../store/user/actions';
import { colors } from '../../../constants/colors';
import { useTranslation } from 'react-i18next';
import HatIcon from '../../../assets/images/png/swap/seek_icon.png';

export const SettingsMenu: React.FC = () => {
  const dispatch = useDispatch();
  const history: History = useHistory();
  const { t } = useTranslation();

  const handleMenuClick = (e: ClickParam): void => {
    switch (e.key) {
      case 'account':
        history.push('/settings/account');
        break;
      case 'faq':
        history.push('/settings/faq');
        break;
      case 'about':
        history.push('settings/about');
        break;
      case 'contact':
        history.push('settings/contactus');
        break;
      case 'terms':
        history.push('settings/terms');
        break;
      case 'logout':
        dispatch(logoutuser());
        message.info('Logged out');
        history.push('/dashboard');
        break;
      default:
    }
  };
  return (
    <Menu
      selectable={false}
      mode="vertical"
      className="profile-menu-container"
      onClick={handleMenuClick}
    >
      <Menu.Item key="account">
        <Row className="item-menu-wrap">
          <FaUserCircle color={colors.iconColor} size={18} />
          <span>{t('My Account')}</span>
        </Row>
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" />
      <Menu.Item key="notification">
        <Row className="item-menu-wrap">
          <FaBell color={colors.iconColor} size={18} />
          <span>{t('Push Notifications')}</span>
        </Row>
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" />
      <Menu.Item key="faq">
        <Row className="item-menu-wrap">
          <FaQuestionCircle color={colors.iconColor} size={18} />
          <span>FAQ</span>
        </Row>
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" />
      {/* <Menu.Item key="rate">
        <FaStar color={colors.iconColor} size={18} />
        <span>Rate MyCookAround</span>
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" /> */}
      <Menu.Item key="about">
        <Row className="item-menu-wrap">
          <img src={HatIcon} alt="hat" style={{ height: 22, width: 21 }} />
          <span>{t('About Us')}</span>
        </Row>
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" />
      <Menu.Item key="contact">
        <Row className="item-menu-wrap">
          <FaEnvelope color={colors.iconColor} size={18} />
          <span>{t('Contact Us')}</span>
        </Row>
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" />
      <Menu.Item key="terms">
        <Row className="item-menu-wrap">
          <FaAlignJustify color={colors.iconColor} size={18} />
          <span>{t('Terms and Conditions')}</span>
        </Row>
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" />
      <Menu.Item key="logout">
        <Row className="item-menu-wrap">
          <FaSignOutAlt color={colors.iconColor} size={18} />
          <span>{t('Sign out')}</span>
        </Row>
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" />
    </Menu>
  );
};
